//////******THIS IS THE CONFIG FILE FOR THE APP******//////

//Address where the contract is deployed
export const contractAddress = "0x33C8e490475942e5e7AB6b958E0Ff0516d0F3574";

//Network where the contract is deployed
export const network = "https://gw.bcerts.al/";
export const ipfsGateway = 'https://ig.bcerts.al';
//export const ipfsGateway = 'http://46.101.169.208:5001';
